var map = {
	"./phone-.png": "NeaN",
	"./phone-AR.png": "I/Zh",
	"./phone-BR.png": "ea/T",
	"./phone-CA.png": "x57x",
	"./phone-CL.png": "+cXk",
	"./phone-CO.png": "cumg",
	"./phone-ES.png": "UlvR",
	"./phone-MX.png": "5pVQ",
	"./phone-UY.png": "tY7Y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7M9j";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/phone\-.*\.png$
// module id = 7M9j
// module chunks = 1